var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocs = function SvgDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 2h9.727a1 1 0 0 1 .672.26l4.274 3.885a1 1 0 0 1 .327.74V17a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1ZM1 3a2 2 0 0 1 2-2h9.727a2 2 0 0 1 1.345.52l4.273 3.885A2 2 0 0 1 19 6.885V17a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Zm8.057 3.568-2.23 4.012 1.853.001c.416 0 .8-.23 1.008-.604l1.262-2.274c.301-.543.122-1.237-.4-1.55a1.07 1.07 0 0 0-1.493.415ZM7.093 13.49h4.46l-.926-1.668a1.155 1.155 0 0 0-1.007-.604H7.093C6.489 11.22 6 11.73 6 12.356c0 .627.49 1.136 1.093 1.136Zm4.53-5.706 2.23 4.012c.302.543.123 1.237-.4 1.55a1.071 1.071 0 0 1-1.492-.415l-1.265-2.272a1.248 1.248 0 0 1 0-1.209l.928-1.666Z",
    clipRule: "evenodd"
  })));
};
export default SvgDocs;